export const GET_BULK_PRICE_TARGETS_START = 'GET_BULK_PRICE_TARGETS_START';
export const GET_BULK_PRICE_TARGETS_SUCCESS = 'GET_BULK_PRICE_TARGETS_SUCCESS';
export const GET_BULK_PRICE_TARGETS_FAILED = 'GET_BULK_PRICE_TARGETS_FAILED';

export const VALIDATE_BULK_PRICE_CSV_START = 'VALIDATE_BULK_PRICE_CSV_START';
export const VALIDATE_BULK_PRICE_CSV_SUCCESS = 'VALIDATE_BULK_PRICE_CSV_SUCCESS';
export const VALIDATE_BULK_PRICE_CSV_FAILED = 'VALIDATE_BULK_PRICE_CSV_FAILED';

export const START_BULK_PRICE_RUN_START = 'START_BULK_PRICE_RUN_START';
export const START_BULK_PRICE_RUN_SUCCESS = 'START_BULK_PRICE_RUN_SUCCESS';
export const START_BULK_PRICE_RUN_FAILED = 'START_BULK_PRICE_RUN_FAILED';

export const GET_BULK_PRICE_RUN_START = 'GET_BULK_PRICE_RUN_START';
export const GET_BULK_PRICE_RUN_SUCCESS = 'GET_BULK_PRICE_RUN_SUCCESS';
export const GET_BULK_PRICE_RUN_FAILED = 'GET_BULK_PRICE_RUN_FAILED';

export const EXPORT_BULK_PRICE_RUN_START = 'EXPORT_BULK_PRICE_RUN_START';
export const EXPORT_BULK_PRICE_RUN_SUCCESS = 'EXPORT_BULK_PRICE_RUN_SUCCESS';
export const EXPORT_BULK_PRICE_RUN_FAILED = 'EXPORT_BULK_PRICE_RUN_FAILED';

export const RECEIVE_BULK_PRICE_PROGRESS = 'RECEIVE_BULK_PRICE_PROGRESS';
export const RESET_BULK_PRICE = 'RESET_BULK_PRICE';

export const getBulkPriceTargetsStart = () => ({
  type: GET_BULK_PRICE_TARGETS_START
});

export const getBulkPriceTargetsSuccess = (data) => ({
  type: GET_BULK_PRICE_TARGETS_SUCCESS,
  data
});

export const getBulkPriceTargetsFailed = (error) => ({
  type: GET_BULK_PRICE_TARGETS_FAILED,
  error
});

export const validateBulkPriceCsvStart = () => ({
  type: VALIDATE_BULK_PRICE_CSV_START
});

export const validateBulkPriceCsvSuccess = (data) => ({
  type: VALIDATE_BULK_PRICE_CSV_SUCCESS,
  data
});

export const validateBulkPriceCsvFailed = (error) => ({
  type: VALIDATE_BULK_PRICE_CSV_FAILED,
  error
});

export const startBulkPriceRunStart = () => ({
  type: START_BULK_PRICE_RUN_START
});

export const startBulkPriceRunSuccess = (data) => ({
  type: START_BULK_PRICE_RUN_SUCCESS,
  data
});

export const startBulkPriceRunFailed = (error) => ({
  type: START_BULK_PRICE_RUN_FAILED,
  error
});

export const getBulkPriceRunStart = () => ({
  type: GET_BULK_PRICE_RUN_START
});

export const getBulkPriceRunSuccess = (data) => ({
  type: GET_BULK_PRICE_RUN_SUCCESS,
  data
});

export const getBulkPriceRunFailed = (error) => ({
  type: GET_BULK_PRICE_RUN_FAILED,
  error
});

export const exportBulkPriceRunStart = () => ({
  type: EXPORT_BULK_PRICE_RUN_START
});

export const exportBulkPriceRunSuccess = () => ({
  type: EXPORT_BULK_PRICE_RUN_SUCCESS
});

export const exportBulkPriceRunFailed = (error) => ({
  type: EXPORT_BULK_PRICE_RUN_FAILED,
  error
});

export const receiveBulkPriceProgress = (data) => ({
  type: RECEIVE_BULK_PRICE_PROGRESS,
  data
});

export const resetBulkPrice = () => ({
  type: RESET_BULK_PRICE
});
